import { Button } from '@/components/ui/button'
import React, { useEffect } from 'react'

import { Label } from '@/components/ui/label'
import CustmomPaymentList from '../components/CustmomPaymentList'

const CustomPayment = ({ handleBack, reservationResp }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  })
  return (
    <>
      <div className='flex justify-end'>
        <Button onClick={() => handleBack()}>Back</Button>
      </div>
      <div className="mb-4">
        <h3 className="text-2xl font-semibold leading-none tracking-tight">
          FonePay
        </h3>
      </div>
      <div className="mb-4">
        <p className="text-sm text-muted-foreground">
          <b>PNR Code - </b>{reservationResp.BookingSummary.PNRNumber}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">

        <div className=''>
          <img src={"/images/gandaki_fonepay.png"} className='w-72	' />

        </div>
        <div>
          <CustmomPaymentList reservationResp={reservationResp} />
        </div>
      </div>


      <p className="text-sm text-muted-foreground "></p>
    </>
  )
}

export default CustomPayment
